import { IsDate, IsNumber, IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantGroupDto } from './merchantGroup.dto';

export class RefundOrderReasonDto extends BaseDto {
  
  @IsNumber()
  id: number;

  @IsString()
  name: string;

  @IsNumber()
  merchantGroupId: number;

  merchantGroup: MerchantGroupDto;
  
  @IsDate()
  startDate?: Date;

  @IsDate()
  @IsOptional()
  endDate?: Date;

  @IsDate()
  createdDate?: Date;

  @IsDate()
  @IsOptional()
  modifiedDate?: Date;

  @IsNumber()
  @IsOptional()
  lastModifiedUserId?: number

  @IsNumber()
  @IsOptional()
  version?: number
}
